import { z } from 'zod';

export const APP_MODULE = {
  SMS: 'SMS',
  PUSH: 'Web Push',
  INTERSTITIAL: 'Interstitial',
  NATIVE_PUSH: 'Native Push',
  VIBER: 'Viber',
  IN_APP: 'In-App',
} as const;

export const PUSH_RETRY_FOR_PERIOD = {
  WEEKS: 'weeks',
  DAYS: 'days',
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
} as const;

export const BUID = {
  UAT: '510001179',
  RETAIL_PROD: '510001039',
  VLT_PROD: '510002563',
  ONLINE_PROD: '510002996',
} as const;

export const APP_MODULE_FEATURE_FLAGS = {
  SMS: 'SMS',
  PUSH: 'WEB_PUSH',
  INTERSTITIAL: 'INTERSTITIAL',
  NATIVE_PUSH: 'NATIVE_PUSH',
  VIBER: 'VIBER',
  IN_APP: 'IN_APP',
} as const;

export const MC_ENTRY_SOURCE = {
  JOURNEY: 'Journey Entry Source',
  DE: 'Data Extension',
  MANUAL: 'Manual',
} as const;

export const ENTRY_DATA_SOURCE = {
  MC_DATA: 'MCData',
  SF_DATA: 'SFData',
  EVENT_DATA: 'EventData',
} as const;

export const SMS_CAMPAIGN_TYPE = {
  ONLINE: 'Online',
  RETAIL: 'Retail',
  VLT: 'VLT',
  NEWSLETTER: 'Newsletter',
} as const;

export const pushRetryTypeValues = ['retryFor', 'retryUntil'] as const;

export const pushRetryTypeEnum = z.enum(pushRetryTypeValues);

export const pushRetryTypeValuesTextMapper: Record<(typeof pushRetryTypeValues)[number], string> = {
  retryFor: 'Retry for',
  retryUntil: 'Retry until',
};

export const pushRetryForPeriodValues = ['weeks', 'days', 'hours', 'minutes', 'seconds'] as const;

export const pushRetryForPeriodEnum = z.enum(pushRetryForPeriodValues);

export const cbTemplateCategoryValues = [
  'Online',
  'Retail',
  'VLT',
  'Newsletter',
  'WebPush',
  'Interstitial',
  'NativePush',
  'ViberOnline',
  'ViberRetail',
  'ViberVLT',
  'InApp',
] as const;

export const cbTemplateCategoryEnum = z.enum(cbTemplateCategoryValues);

export const appModuleValues = ['SMS', 'PUSH', 'INTERSTITIAL', 'NATIVE_PUSH', 'VIBER', 'IN_APP'] as const;

export const toastTypeValues = ['success', 'info', 'warning', 'danger'] as const;

export const toastTypeEnum = z.enum(toastTypeValues);

export const entryDataSourceValues = ['MCData', 'SFData', 'EventData'] as const;

export const entryDataSourceEnum = z.enum(entryDataSourceValues, { message: 'Invalid entry data source' });

export const xpGameIdTypes = ['SB', 'CASINO', 'LOTTERY'] as const;

export const xpGameIdEnum = z.enum(xpGameIdTypes);

export const xpProjectCategoryTypes = ['sb', 'casino', 'lottery'] as const;

export const xpProjectCategoryEnum = z.enum(xpProjectCategoryTypes);

export const nativeOsTypes = ['android', 'ios'] as const;

export const nativeOsEnum = z.enum(nativeOsTypes);

export const mgNativeOsTypes = ['ANDROID', 'IOS'] as const;

export const mgNativeOsEnum = z.enum(mgNativeOsTypes);
